import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {VisitLabTestDataDgSearchResults} from "../models/datagrid-search-results/visit-lab-test-data.dg-search-results.model";
import {VisitLabTestDataService} from "../providers/visit-lab-test-data.service";

@Injectable()
export class LabTestDataResolve implements Resolve<VisitLabTestDataDgSearchResults> {
  constructor(private visitLabTestDataService: VisitLabTestDataService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<VisitLabTestDataDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.visitLabTestDataService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'DESC', 'created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
